import { ReactNode } from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import type { SummarySubItem } from '../../types';

import { cn } from 'support/helpers/cn/cn';

type CollapsibleSummaryRowProps = {
  label: ReactNode;
  value: ReactNode;
  subItems: Array<SummarySubItem>;
  defaultOpen?: boolean;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
  subItemsClassName?: string;
};

export const CollapsibleSummaryRow = ({
  label,
  value,
  subItems,
  defaultOpen = false,
  className,
  labelClassName,
  valueClassName,
  subItemsClassName,
}: CollapsibleSummaryRowProps) => (
  <Disclosure defaultOpen={defaultOpen}>
    {({ open }) => (
      <>
        <DisclosureButton className={cn('flex w-full items-center justify-between gap-4 text-start', className)}>
          <span className={cn('flex min-w-0 items-center gap-1', labelClassName)}>
            {label}
            <ChevronDownIcon
              aria-hidden="true"
              className={cn('size-4 shrink-0 transition-transform', open && 'rotate-180')}
            />
          </span>
          <span className={cn('shrink-0 text-end', valueClassName)}>{value}</span>
        </DisclosureButton>
        <DisclosurePanel className={cn('flex flex-col gap-2 pt-2 pl-4', subItemsClassName)}>
          {subItems.map((item) => (
            <div key={item.label} className="flex items-center justify-between gap-4">
              <span className={labelClassName}>{item.label}</span>
              <span className={cn('shrink-0 text-end', valueClassName)}>{item.value}</span>
            </div>
          ))}
        </DisclosurePanel>
      </>
    )}
  </Disclosure>
);
